import * as Yup from 'yup';
import { TFunction } from 'i18next';

export const passwordResetSchema = (t: TFunction) =>
  Yup.object().shape({
    passwordResetEmail: Yup.string()
      .email(t('validation.invalidEmail'))
      .required(t('validation.required')),
  });
